import { useEffect, useMemo, useState } from "react";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import ActionButton from "./ActionButton";

const AssignmentModal = ({
  open,
  onClose,
  onSubmit,
  loading = false,

  // generic props
  entities = [],
  roles = [],
  entityLabel = "Item",
  getEntityLabel = (e) => e.name || e.displayName || "Item",
  requirePrimary = false,
}) => {
  const [entityId, setEntityId] = useState("");
  const [roleId, setRoleId] = useState("");
  const [isPrimary, setIsPrimary] = useState(true);

  useEffect(() => {
    if (!open) return;
    setEntityId("");
    setRoleId("");
    setIsPrimary(true);
  }, [open]);

  const sortedEntities = useMemo(() => {
    return [...entities].sort((a, b) =>
      getEntityLabel(a).localeCompare(getEntityLabel(b))
    );
  }, [entities, getEntityLabel]);

  const sortedRoles = useMemo(() => {
    return [...roles].sort((a, b) =>
      (a.name || "").localeCompare(b.name || "")
    );
  }, [roles]);

  const handleSubmit = async () => {
    if (!entityId || !roleId) return;

    await onSubmit({
      entityId,
      roleId,
      isPrimary,
    });
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Assign {entityLabel} to Role</DialogTitle>

      <DialogContent sx={{ display: "grid", gap: 2, pt: 2 }}>
        <FormControl fullWidth>
          <InputLabel>{entityLabel}</InputLabel>
          <Select
            value={entityId}
            label={entityLabel}
            onChange={(e) => setEntityId(e.target.value)}
            disabled={loading}
          >
            {sortedEntities.map((entity) => (
              <MenuItem key={entity.id} value={entity.id}>
                {getEntityLabel(entity)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Role</InputLabel>
          <Select
            value={roleId}
            label="Role"
            onChange={(e) => setRoleId(e.target.value)}
            disabled={loading}
          >
            {sortedRoles.map((role) => (
              <MenuItem key={role.id} value={role.id}>
                {role.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {requirePrimary && (
          <FormControlLabel
            control={
              <Checkbox
                checked={isPrimary}
                onChange={(e) => setIsPrimary(e.target.checked)}
                disabled={loading}
              />
            }
            label="Primary role"
          />
        )}
      </DialogContent>

      <DialogActions>
        <ActionButton tone="ghost" onClick={onClose} disabled={loading}>
          Cancel
        </ActionButton>
        <ActionButton
          tone="success"
          onClick={handleSubmit}
          disabled={loading || !entityId || !roleId}
        >
          Assign
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default AssignmentModal;